<template>
  <SoWidget no-padding>
    <div class="w-100 overflow-x-auto">
      <div class="d-flex justify-space-between">
        <DebtMonthlyPaymentWidget />
        <SoDivider vertical class="mx-1 h-auto" />
        <PlanLengthRemainingWidget />
        <SoDivider vertical class="mx-1 h-auto" />
        <RemainingDebtBalanceWidget />
      </div>
    </div>
  </SoWidget>
</template>

<script lang="ts">
  import SoDivider from "@/components/SoDivider.vue"
  import SoWidget from "@/components/SoWidget.vue"
  import { defineComponent } from "vue"
  import DebtMonthlyPaymentWidget from "./DebtMonthlyPaymentWidget.vue"
  import PlanLengthRemainingWidget from "./PlanLengthRemainingWidget.vue"
  import RemainingDebtBalanceWidget from "./RemainingDebtBalanceWidget.vue"

  export default defineComponent({
    components: {
      SoWidget,
      SoDivider,
      DebtMonthlyPaymentWidget,
      PlanLengthRemainingWidget,
      RemainingDebtBalanceWidget,
    },
  })
</script>
